module.exports = {"name":"Mathias Schilling","contact":{"email":"m@matchilling.com","github":"https://github.com/matchilling","instagram":"https://www.instagram.com/matchilling/","lastfm":"https://www.last.fm/user/msatlastfm","linkedin":"https://www.linkedin.com/in/matchilling","reddit":"https://www.reddit.com/user/matchilling","twitter":"https://twitter.com/MatChilling"}}


//////////////////
// WEBPACK FOOTER
// ./data/profile.json
// module id = 36
// module chunks = 70144966829960 131683993344931 212839066777427